// extracted by mini-css-extract-plugin
module.exports = {"locl-search-criteria-tags":"search-criteria-tags_locl-search-criteria-tags__MQGAK","locl-search-criteria-tags__box":"search-criteria-tags_locl-search-criteria-tags__box__xEV_f"};